export default __webpack_public_path__ + "static/media/left.64e7ab99.svg";